import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_ORGANIZATION_PLOT_GROUP_COMPARISONS_PATH,
  GetOrganizationPlotGroupComparisonsErrorDto,
  GetOrganizationPlotGroupComparisonsSuccessDto,
} from '@/api/rest/resources/types/organization';
import { assertIsDefined } from '@/utils/assert';
import { isNullish } from '@/utils/booleans';

type SuccessDto = GetOrganizationPlotGroupComparisonsSuccessDto;
type ErrorDto = GetOrganizationPlotGroupComparisonsErrorDto;

export const useOrganizationPlotGroupComparisons = (organizationIdArg: string) => {
  const id = organizationIdArg;

  assertIsDefined(id, 'organizationId');

  const queryFn = () => {
    return getRequest<SuccessDto>(GET_ORGANIZATION_PLOT_GROUP_COMPARISONS_PATH, { organization_id: id });
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', id, 'plot-group-comparisons'],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};

export const useOrganizationPlotGroupComparison = (organizationId: string, plotGroupComparisonId?: string | null) => {
  const plotGroupComparisons = useOrganizationPlotGroupComparisons(organizationId).data;

  if (isNullish(plotGroupComparisonId)) {
    return null;
  }
  return plotGroupComparisons.find((group) => group.id === plotGroupComparisonId);
};
